// import getAppName from '../getAppName';
// // webLogger中已经强依赖，无法懒加载
// import * as YodaBridges from '@yoda/bridge';
// import randomChars from '../randomChars';
// import getAppName from '../getAppName';
// android 下载apk 9230支持
export async function downloadApk(url) {
    // if (getAppName() === 'kwai') {
    //     window.location.href = url;
    //     //     const fileName = url?.split('--')?.[1] || 'com.kwai.videoeditor.apk';
    //     //     // @ts-expect-error 试了一下该方法不支持
    //     //     return YodaBridges.invoke('system.installApk', {
    //     //         action: 'start',
    //     //         // start 重新开始 resume 继续或重新下载 pause 暂停 stop 停止
    //     //         url,
    //     //         // 下载地址
    //     //         downloadId: randomChars(10),
    //     //         downloadName: fileName,
    //     //     });
    // }
    window.location.href = url;
}
